module.exports = __webpack_public_path__ + "static/media/about.8b64f253.png";